import { render, staticRenderFns } from "./LandingSubsidy.vue?vue&type=template&id=6e73ba22&"
import script from "./LandingSubsidy.vue?vue&type=script&lang=js&"
export * from "./LandingSubsidy.vue?vue&type=script&lang=js&"
import style0 from "./LandingSubsidy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports